
import { defineComponent, reactive, toRefs, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import UsbTerminalService, {
  getPeripheralTypeLabel,
  EquipmentItem,
  QueryParams
} from '@/views/dashboard/data-safe/usb-manage/usb-statistics/_components/terminal-view/_components/usb-terminal.service'
import { TerminalItem } from '@/views/dashboard/data-safe/usb-manage/usb-statistics/_components/terminal-view/terminal-view.service'
import { formatTableEmpty } from '@/utils/format'
export default defineComponent({
  components: {
    ContentAdaptLayout,
  },
  props: {
    currentTerminal: {
      type: Object as PropType<TerminalItem>,
      default: {} as PropType<TerminalItem>
    },
    peripheralStatus: {
      type: Number,
      default: 3
    },
    timeRange: {
      type: Number,
      default: 1
    }
  },
  setup (props) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([UsbTerminalService])
    const service = injector.get(UsbTerminalService)
    const queryParams = reactive<QueryParams>({
      device_id: (props.currentTerminal as TerminalItem).device_id,
      peripheral_status: props.peripheralStatus as number,
      time_range: props.timeRange as number,
      page: 1,
      limit: 10
    })
    const data = reactive({
      tableData: [] as EquipmentItem[],
      total: 0
    })
    function getData (isOperatePage:boolean = false) {
      !isOperatePage && (queryParams.page = 1)
      service.getEquipmentList(queryParams).then(res => {
        data.tableData = res.list
        data.total = res.total
      })
    }
    getData()
    function peripheralTypeLabel (type: number) {
      return getPeripheralTypeLabel(type, t)
    }
    return {
      ...toRefs(data),
      queryParams,
      peripheralTypeLabel,
      formatTableEmpty,
      handlerSizeChange (size: number) {
        queryParams.limit = size
        getData()
      },
      handlerCurrentChange (page: number) {
        queryParams.page = page
        getData(true)
      },
    }
  }
})
